import { entranceKindLabel, entranceResultLabel } from '@/lib/labels';
import { int, isoDate, oneOf, optionsOf, text, uuid } from '@/hooks/useUrlState';
import type { EntranceKind, EntranceResult } from '@/gql/graphql';

/** Every `EntranceResult` in the order the filter lists them, with its label. */
export const ENTRANCE_RESULT_LABELS: Record<EntranceResult, string> = {
  VALID: entranceResultLabel('VALID'),
  REFUSED: entranceResultLabel('REFUSED'),
  BLOCKED: entranceResultLabel('BLOCKED'),
  ALREADY_SCANNED: entranceResultLabel('ALREADY_SCANNED'),
  EXPIRED_QR: entranceResultLabel('EXPIRED_QR'),
  DECRYPT_FAILED: entranceResultLabel('DECRYPT_FAILED'),
  NO_DOORS_WINDOW: entranceResultLabel('NO_DOORS_WINDOW'),
  WRONG_NIGHT: entranceResultLabel('WRONG_NIGHT'),
  // The server still emits this value for a wrong-night scan (DEPRECATIONS.md#wrong-production-wire); the filter lists WRONG_NIGHT only.
  WRONG_PRODUCTION: entranceResultLabel('WRONG_PRODUCTION'),
};

export const ENTRANCE_KIND_LABELS: Record<EntranceKind, string> = {
  CLAIMED: entranceKindLabel('CLAIMED'),
  GOLDEN: entranceKindLabel('GOLDEN'),
  DOOR: entranceKindLabel('DOOR'),
};

export const ENTRANCE_RESULT_OPTIONS = optionsOf(ENTRANCE_RESULT_LABELS, 'Any result').filter((option) => option.value !== 'WRONG_PRODUCTION');
export const ENTRANCE_KIND_OPTIONS = optionsOf(ENTRANCE_KIND_LABELS, 'Any type');

/** The /entrance-scans query string, in this order (see README "List pages, URL state"). */
export const entranceScansUrlSchema = {
  search: text(),
  result: oneOf(ENTRANCE_RESULT_LABELS, ''),
  kind: oneOf(ENTRANCE_KIND_LABELS, ''),
  night: uuid(),
  from: isoDate(),
  to: isoDate(),
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 25),
};
